import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IconCalendarEvent, IconCalendarCheck, IconCalendarStats, IconArrowLeft } from "@tabler/icons-react";
import LayoutHR from "layouts/layout-hr";
import { URLS } from "utils/constants";
import { UserProvider } from "contexts/v1/masterData/UserContext";

// Import Tabs
import PHHubQuotaTab from "./components/ph-hub-quota-tab";
import PHHubUseTab from "./components/ph-hub-use-tab";
import PHHubRecapTab from "./components/ph-hub-recap-tab";

import "./public-holiday-quota-page.css";
import "./public-holiday-hub-page.css";

const PublicHolidayHubPage = () => {
  const [activeTab, setActiveTab] = useState("quota");

  return (
    <LayoutHR>
      <div className="p-3 public-holiday-hub-page">
        <div className="row align-items-center mb-4 g-3">
          <div className="col">
            <div className="text-muted small fw-bold text-uppercase ls-1 mb-1">HR Operations</div>
            <h1 className="m-0 fw-bold h2 d-flex align-items-center gap-2">
              <IconCalendarEvent size={28} className="text-primary" />
              Public Holiday Management
            </h1>
            <div className="text-muted mt-1">Pusat pengaturan cuti bersama, alokasi penggunaan, dan rekapitulasi.</div>
          </div>
          <div className="col-auto">
            <Link to={URLS.v1.HR_MANAGE} className="btn btn-light border">
              <IconArrowLeft size={17} className="me-1" /> Kembali
            </Link>
          </div>
        </div>

        <div className="card shadow-sm border-0 mb-4">
          <div className="card-header p-0">
            <ul className="nav nav-tabs card-header-tabs nav-fill m-0 public-holiday-hub-tabs">
              <li className="nav-item">
                <button
                  className={`nav-link py-3 fw-medium ${activeTab === "quota" ? "active text-primary" : "text-muted"}`}
                  onClick={() => setActiveTab("quota")}
                >
                  <IconCalendarEvent size={18} className="me-2" />
                  Packages & Quota
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link py-3 fw-medium ${activeTab === "use" ? "active text-info" : "text-muted"}`}
                  onClick={() => setActiveTab("use")}
                >
                  <IconCalendarCheck size={18} className="me-2" />
                  Input Penggunaan
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link py-3 fw-medium ${activeTab === "recap" ? "active text-success" : "text-muted"}`}
                  onClick={() => setActiveTab("recap")}
                >
                  <IconCalendarStats size={18} className="me-2" />
                  Rekap Pemakaian
                </button>
              </li>
            </ul>
          </div>

          <div className="card-body p-0">
            {/* Wrap tabs with providers needed by them */}
            <UserProvider roleFilter="user_hr">
              {activeTab === "quota" && <PHHubQuotaTab setActiveTab={setActiveTab} />}
              {activeTab === "use" && <PHHubUseTab setActiveTab={setActiveTab} />}
              {activeTab === "recap" && <PHHubRecapTab />}
            </UserProvider>
          </div>
        </div>
      </div>
    </LayoutHR>
  );
};

export default PublicHolidayHubPage;
